// [ai] Entry point: the long-lived objects (query client, shell store, player store + controller, browser router), mounted once under <App/>.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient } from "@tanstack/react-query";
import { createBrowserRouter } from "react-router";
import { App } from "./app/App";
import { ROUTES } from "./app/routes";
import { Importer } from "./imports/importer";
import { Astra } from "./chat/astra";
import { Player } from "./player/player";
import { createPlayerStore } from "./stores/player";
import { createShellStore } from "./stores/shell";
import { Widgets } from "./widgets/widgets";
import { exposeVendor } from "./sdk/vendor";
import { startDiag } from "./core/diag";
import "./styles/tokens.css";
import "./styles/shell.css";
import "./styles/player.css";
import "./styles/pages.css";
import "./styles/chat.css";
import "./styles/widgets.css";
import "./styles/life.css";

exposeVendor();   // before any trusted module can import "react": the shims under /sdk read this

const client = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false } } });   // /api/events invalidates; no polling
const store = createShellStore();
const router = createBrowserRouter(ROUTES);
const player = new Player({ client, store: createPlayerStore(), navigate: to => void router.navigate(to) });
const astra = new Astra({ client, toast: (t, o) => player.toast(t, o), navigate: to => void router.navigate(to), pathname: () => location.pathname, playing: () => (player.item ? { title: player.item.title, t: player.engine.time } : null) });
const widgets = new Widgets({ player, astra, navigate: to => void router.navigate(to) });
const importer = new Importer({ client, toast: (t, o) => player.toast(t, o), navigate: to => void router.navigate(to), pathname: () => location.pathname });
createRoot(document.getElementById("root")!).render(<StrictMode><App client={client} store={store} player={player} importer={importer} astra={astra} widgets={widgets} router={router} /></StrictMode>);
startDiag();   // only under ?diag=<tag>: the device harness's beacon (core/diag.ts) reads window.__dossier lazily
